import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { IconModule } from '@spartacus/storefront'
import { SharedModule } from '../../../../shared/shared.module'
import { NewDispenserAgreementModalComponent } from './new-dispenser-agreement-modal.component'

@NgModule({
  declarations: [NewDispenserAgreementModalComponent],
  imports: [CommonModule, SharedModule, IconModule, ReactiveFormsModule]
})
export class NewDispenserAgreementModalModule {}
